import {gsap} from "gsap";

// noinspection DuplicatedCode
function setLoadState(item) {
    if (!item.getAttribute('data-transitioning')) {
        let spinner = item.querySelector('.button__spinner');

        let bWidth = item.offsetWidth;
        let bHeight = item.offsetHeight;
        let pLeft = item.style.paddingLeft;
        let pRight = item.style.paddingRight;

        item.setAttribute('data-disabled', 'true');
        item.setAttribute('data-origin-width', bWidth);
        item.setAttribute('data-origin-padding-left', pLeft);
        item.setAttribute('data-origin-padding-right', pRight);

        gsap.set(item, {width: bWidth, paddingLeft: pLeft, paddingRight: pRight});

        // noinspection JSCheckFunctionSignatures
        // let tl = gsap.timeline({ onComplete: () => gsap.set(item, {clearProps: 'width,paddingLeft,paddingRight'}) });
        let tl = gsap.timeline();
        item.classList.add('is-loading');
        item.setAttribute('data-transitioning', 'true');
        // noinspection JSSuspiciousNameCombination
        tl.to(item, {
            width: bHeight,
            paddingLeft: 0,
            paddingRight: 0,
            duration: 0.4,
            ease: 'power2.inOut'
        })
            .add(() => {
                spinner.style.display = 'block'
                item.removeAttribute('data-transitioning');
            })
            .to(spinner, {opacity: 1, duration: 0.2, ease: 'circ.inOut'});
    } else {
        setTimeout(() => setLoadState(item), 300);
    }
}

function killLoadState(item) {
    if (!item.getAttribute('data-transitioning')) {
        let spinner = item.querySelector('.button__spinner');
        let bTargetWidth = item.getAttribute('data-origin-width');
        let pTargetLeft = item.getAttribute('data-origin-padding-left');
        let pTargetRight = item.getAttribute('data-origin-padding-right');
        let bWidth = item.offsetWidth;
        let pLeft = item.style.paddingLeft;
        let pRight = item.style.paddingRight;
        gsap.set(item, {width: bWidth, paddingLeft: pLeft, paddingRight: pRight});
        item.setAttribute('data-transitioning', 'true');
        let tlr = gsap.timeline({
            onComplete: () => {
                item.classList.remove('is-loading')
                gsap.set(item, {clearProps: 'all'});
                item.removeAttribute('data-disabled');
            }
        });
        tlr.to(spinner, {opacity: 0, duration: 0.2, ease: 'circ.out'})
            .add(() => {
                spinner.style.display = 'none';
                item.removeAttribute('data-transitioning');
            })
            .fromTo(item, {
                width: bWidth,
                paddingLeft: pLeft,
                paddingRight: pRight,
            }, {
                width: bTargetWidth,
                paddingLeft: pTargetLeft,
                paddingRight: pTargetRight,
                duration: 0.4,
                ease: 'power2.inOut'
            });
    } else {
        setTimeout(() => killLoadState(item), 300);
    }
}

let init = (button) => {
    button.addEventListener('start-loading', () => setLoadState(button));
    button.addEventListener('stop-loading', () => killLoadState(button));
}

document.addEventListener("DOMContentLoaded", () => document.querySelectorAll('.js-button-loading-state').forEach(init));
